<template>
	<img class="opt-img" :src="`${require('@assets/images/dywfl/xmjs.jpg')}`" alt="" style="width: 100%;height: 100%;">
</template>

<script>
export default {
  name: "Intro_Index",
  data: function() {
    return {
    };
  },
  mounted(){
  },
  methods: {

  }
};
</script>
